import ContainerPresenter from "./container.js";

export default class Containers {
  constructor(containersElements) {
    this._containersElements = containersElements;
    this._containersPresenters = [];
  }

  init() {
    Array.from(this._containersElements)
      .forEach((container) => {
        const presenter = new ContainerPresenter(container);
        presenter.init();

        this._containersPresenters.push(presenter);
      });
  }
}
